import React from 'react';

import { InfoHeaderInventory } from '../../../../../components/Generic/InfoHeaderInventory';
import QuotedInventory from '../../../../../components/Generic/QuotedInventory';
import { Sales } from '../../../../../models/sales';
import { Container } from "./styles";

interface InventoryProps {
  job?: Sales;
}

export const Inventory = (props: InventoryProps) => {
  const { job } = props;

  return (
    <Container>
      <InfoHeaderInventory inventory={job?.inventory} onCustomerView />
      <QuotedInventory
        inventory={job?.inventory ?? []}
        defaultMode={job?.mode ?? ""}
        jobId={job?.id ?? 0}
        locations={job?.destination?.locations ?? []}
        externalList={{jobModeList: job?.jobModeList, destinationList: job?.destinationList}}
        viewOnly
        onCustomerView
      />
    </Container>
  )
}
